module.exports = __webpack_public_path__ + "static/media/user.ada11b9b.svg";